const getReportCardEnv = () => {
  const productionUrl = process.env.REACT_APP_PRODUCTION_URL || ''
  if (productionUrl.includes('ams-stg')) {
    return 'stg'
  }
  return 'prod'
}

export const hasGeneratedReportCard = (candidateDetails?: { section_level_details?: unknown; score_card_url?: string | null }) =>
  Boolean(candidateDetails?.section_level_details || candidateDetails?.score_card_url)

export const getMobileReportCardDownloadUrl = (candidateId: string, testType: string) => {
  const baseUrl = process.env.REACT_APP_PRODUCTION_URL || window.location.origin
  const env = getReportCardEnv()
  const params = new URLSearchParams({
    env,
    testType: (testType || 'tq').toLowerCase(),
    candidateId,
    mobilePdf: '1',
  })

  return `${baseUrl}/download/scorecard-pdf?${params.toString()}`
}
